import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const PostOff = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.19324 11.2709L5.19323 39.0525C5.19681 40.3154 5.7001 41.5256 6.59314 42.4186C7.48618 43.3117 8.69637 43.815 9.95932 43.8186L37.7409 43.8186L32.9748 39.0525L9.95932 39.0525L9.95933 16.037L5.19324 11.2709Z"
        fill={color}
      />
      <path
        d="M24.7948 19.0363L20.0288 14.2703L33.7891 14.2703V19.0363L24.7948 19.0363Z"
        fill={color}
      />
      <path d="M15.8176 21.8952H14.7254V26.6613H20.5836L15.8176 21.8952Z" fill={color} />
      <path d="M32.4198 26.6613L27.6537 21.8952H33.7891V26.6613H32.4198Z" fill={color} />
      <path
        d="M38.5544 32.7959L38.5544 10.4574L16.2159 10.4574L11.4498 5.69125L38.5545 5.69126C39.8174 5.69484 41.0276 6.19814 41.9206 7.09117C42.8137 7.98421 43.317 9.19441 43.3205 10.4574V37.562L38.5544 32.7959Z"
        fill={color}
      />
      <path
        d="M23.4434 29.521L14.7254 29.521L14.7254 34.2871L28.2095 34.2871L23.4434 29.521Z"
        fill={color}
      />
      <path
        d="M3.33337 6.62119L6.62119 3.33337L46.6667 43.3789L43.3789 46.6667L3.33337 6.62119Z"
        fill={color}
      />
    </svg>
  )
}
